<template>
  <div class="pwc-product-item">
    <van-image
      class="pwc-product-cover"
      :src="product.coverUrl"
      height="220px"
    />

    <div class="pwc-product-content">
      <p class="pwc-product-title">{{ product.name }}</p>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div class="pwc-product-intro" v-html="product.productDesc" />
    </div>

    <div class="pwc-product-action">
      <van-button plain hairline size="small" type="primary" @click="register(product)">申请项目</van-button>
    </div>
  </div>

</template>

<script>
import { Image, Button } from 'vant'

export default {
  components: {
    VanImage: Image,
    VanButton: Button
  },
  props: {
    product: {
      type: Object,
      default: () => { return {} }
    },
    register: {
      type: Function,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.pwc-product-item {
    margin: 12px;
    margin-bottom: 24px;
    background-color: #fff;
    .pwc-product-cover {
        display: block;
    }
    .pwc-product-content {
        margin: 12px;
        margin-bottom: 18px;
        .pwc-product-title {
            font-size: 16px;
            font-weight: bold;
         }
        .pwc-product-intro {
            margin-top: 6px;
            font-size: 14px;
            color:#9e9e9e;
        }
    }
    .pwc-product-action {
        display: flex;
        justify-content:flex-end;
        >button {
            display: block;
            margin: 8px;
        }
    }
}
</style>
